import React from 'react'
import clsx from 'clsx'

import type { KinerjaHarianBadgeTone } from 'types/kinerja-harian'

const BADGE_TONE_CLASSNAMES: Record<KinerjaHarianBadgeTone, string> = {
  warning: 'bg-[#FEF3C7] text-[#92400E]',
  success: 'bg-[#E2F5E0] text-success',
  failed: 'bg-surface-critical-default text-critical',
  informational: 'bg-cyan-5 text-blue-50',
}

interface KinerjaHarianStatusBadgeProps {
  children: React.ReactNode
  className?: string
  tone: KinerjaHarianBadgeTone
}

export function KinerjaHarianStatusBadge({
  children,
  className,
  tone,
}: KinerjaHarianStatusBadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-md px-3 py-1.5 text-sm font-semibold leading-none whitespace-nowrap',
        BADGE_TONE_CLASSNAMES[tone],
        className
      )}
    >
      {children}
    </span>
  )
}
